module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAMCAYAAABbayygAAAAAXNSR0IArs4c6QAAAQVJREFUKFN9z7ErhHEcx/H355dEuSzKM5komQy6XZlsJF0UTgaUuGwyGGS6M1lucUUG1+NvMBnsFoPBRCnpyQ10nq+e53HyI/ddfv2+vX7fz/cnvmq9bj2uk0PBdNKKY8Lole3TBTWSu1pwNbRQjvuuJruNbuTeODAIqjMqfMOlugXug6vjAoNIlj7eM7c8zJ058rVZPaUT52o2Kkf5bFETrYTknD+xy+Y7G+crutFU1S6cGEMEZkQ/oaAXeIiNa00eWRbVvkzjlT/wUZAs2u9Nz+/70IwK0CGx6cGRHR/GRlkZ3PLgQOlXtHFr4CSGPNi3Zi9kv2tXz8oVrWhK98r9IyMHpU+j3lZkXNiDjgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/login_psswd.png
// module id = QFe/
// module chunks = 4